import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';


import { QueryClientProvider } from "@tanstack/react-query";
import '../css/style.scss'; // Revert back to importing the main SCSS file
// import '../css/mixins/variables.scss'; // Remove diagnostic import
import { queryClient } from "./api/api.config.js";
import App from './App.jsx';
import posthog from 'posthog-js';
import { PostHogProvider, PostHogErrorBoundary } from 'posthog-js/react';

if (import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    defaults: '2026-01-30',
    capture_pageview: 'history_change',
    capture_pageleave: true,
  });
}
import { AuthProvider } from './context/AuthContext.jsx';
import { SocketProvider } from './context/SocketContext.jsx';
import { initializeSearchAndAds } from './utils/googleAdsense.js';


initializeSearchAndAds();

// Updated message to trigger a new hash
console.log('App initialized with timestamp: ' + new Date().toISOString());

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <SocketProvider>
            <PostHogProvider client={posthog}>
              <PostHogErrorBoundary>
                <App />
              </PostHogErrorBoundary>
            </PostHogProvider>
          </SocketProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
// Force rebuild Fri May  9 17:08:35 IST 2025
